import Reports from 'views/reports';

const LoggedInRoutes = [
    { path: "/report", name: "Report", component: Reports },
    { path: "/", pathTo:"/report",redirect:true}
];

export default LoggedInRoutes;



// WEBPACK FOOTER //
// ./src/routes/loggedInRoute.jsx